import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { CreditCardList } from "./creditCardList"
import { useCreditCardLoaders } from "../../../loaders/creditCardLoaders"
import { CreditCard } from "../../../state/types"
import { TableName } from "../../../../../tables"
import { ListLoaderWrapper } from "../../../../../features/data-types"

export const Loader = () => {
    const [creditCards, setCreditCards] = useState<CreditCard[]>([])
    const [ready, setReady] = useState(false)

    const creditCardLoaders = useCreditCardLoaders()

    const populate = async () => {
        const { loadAllCreditCards } = creditCardLoaders()
        setCreditCards(await loadAllCreditCards())
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Tarjetas"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.CREDIT_CARDS} />}
        >
            <CreditCardList creditCards={creditCards} />
        </PanelLoader>
    )
}

export const CreditCardListLoader = () => (
    <ListLoaderWrapper table={TableName.CREDIT_CARDS}>
        <Loader />
    </ListLoaderWrapper>
)
